import axios from 'axios';
axios.defaults.withCredentials = true;
const isMock = process.env.IS_MOCK;

const ajaxDefaultConfig = {
  baseURL: isMock ? 'http://localhost:8082/mock' : './',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
};
const instance = axios.create(ajaxDefaultConfig);

instance.interceptors.response.use(
  (response) => {
    // if (response.data && response.data.code) {
    //   const code = response.data.code;
    //   if (code === -5001) {
    //     // 无登录，跳登录页
    //     location.href = `//${location.hostname}/resources/index.html?needLogin=1&oasisRedirectUrl=${encodeURIComponent(location.href)}`;
    //   } else if (code === -6001) {
    //     // 无权限，跳无权限页面
    //     location.href = `//${location.hostname}/resources/index.html?oasisAuth=false`;
    //   }
    // }
    return response.data;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  },
);
export const httpRequest = instance;
